import { ButtonHTMLAttributes, CSSProperties, forwardRef, ReactChild } from "react";
import cx from "classnames";

import { convertPropsToClassNames } from "./convertPropsToClassNames";
import Icon, { IconTypes } from "../Icon";

export enum ButtonVariant {
    PRIMARY,
    SECONDARY,
    LINED_PRIMARY,
    LINED_SECONDARY,
    PAPER,
}

export interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    /**
     * Variant
     */
    variant?: ButtonVariant;
    /* text in hover */
    hoverText?: string;
    /**
     * Is the button size big
     */
    big?: boolean;
    /**
     * Left icon type
     */
    leftIcon?: IconTypes;
    /**
     * Left icon size
     */
    leftIconSize?: number;
    /**
     * Single icon for icon button
     */
    icon?: IconTypes;
    /**
     * Icon size
     */
    iconSize?: number;
    /**
     * Text content
     */
    text?: ReactChild;
    /**
     * Right icon type
     */
    rightIcon?: IconTypes;
    /**
     * Right icon size
     */
    rightIconSize?: number;
    /**
     * is button active
     */
    active?: boolean;
    /**
     * Styles for button icons
     */
    iconStyles?: CSSProperties;
}

const Button = forwardRef<HTMLButtonElement, IProps>((props, ref) => {
    const {
        leftIcon,
        leftIconSize,
        icon,
        iconSize,
        text,
        hoverText,
        rightIcon,
        rightIconSize,
        variant,
        big,
        className,
        active,
        iconStyles,
        ...params
    } = props;

    return (
        <button className={cx(convertPropsToClassNames(props), className)} ref={ref} {...params}>
            {icon ? (
                <Icon type={icon} size={iconSize} styles={iconStyles ? iconStyles : {}} />
            ) : (
                <>
                    {leftIcon && <Icon type={leftIcon} size={leftIconSize} styles={iconStyles ? iconStyles : {}} />}
                    {text}
                    {rightIcon && <Icon type={rightIcon} size={rightIconSize} styles={iconStyles ? iconStyles : {}} />}
                </>
            )}
            {hoverText ? <span>{hoverText}</span> : null}
        </button>
    );
});

Button.defaultProps = {
    variant: ButtonVariant.PRIMARY,
    big: true,
};

export default Button;
